import { render, staticRenderFns } from "./appSortAssetList.vue?vue&type=template&id=72bf59ab&scoped=true"
import script from "./appSortAssetList.vue?vue&type=script&lang=js"
export * from "./appSortAssetList.vue?vue&type=script&lang=js"
import style0 from "./appSortAssetList.vue?vue&type=style&index=0&id=72bf59ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf59ab",
  null
  
)

export default component.exports